import { intl } from "@tci18n/vue2";import Main from '@/view/public/main';

// 报表
export default [
{
  path: '/report',
  name: 'hrms_report',
  redirect: 'report',
  component: Main,
  meta: {
    title: intl.$t("报表")
  },
  icon: 'hrms_report',
  children: [
  {
    path: '/report/dashboard',
    name: 'hrms_dashboard',
    meta: {
      title: intl.$t("数据大盘"),
      menuName: 'hrms_dashboard'
    },
    component: () => import('./dashboard/index.vue')
  },
  {
    path: '/report/revenueLog',
    name: 'hrms_revenueLog',
    meta: {
      title: intl.$t("入账日志"),
      menuName: 'hrms_revenueLog'
    },
    component: () => import('./revenueLog/index.vue')
  }]

}];